import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/** Trailing time-range selector for charts (months; 0 = whole history). */
@Component({
  selector: 'app-range-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './range-toggle.component.html',
  styleUrl: './range-toggle.component.scss',
})
export class RangeToggleComponent {
  readonly options = [
    { label: '2 г', months: 24 },
    { label: '5 г', months: 60 },
    { label: '10 г', months: 0 },
  ];
  value = input.required<number>();
  change = output<number>();
}
